var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52.048,
    viewBox: "0 0 52 52.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_7142",
    "data-name": "Groupe 7142",
    transform: "translate(-137 -162.968)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "picture",
    transform: "translate(137 162.968)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680",
    "data-name": "Rectangle 680",
    width: 30,
    height: 30,
    rx: 6,
    transform: "translate(0 0.032)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_9820",
    "data-name": "Trac\\xE9 9820",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 28.69346046447754 25.51174545288086 L 16.37711143493652 13.19539451599121 C 15.00778102874756 11.82570457458496 13.1869010925293 11.07133483886719 11.25000095367432 11.07133483886719 C 9.313091278076172 11.07133483886719 7.492220878601074 11.82570457458496 6.122800827026367 13.19548511505127 L 1.000000953674316 18.31828498840332 L 1.000000953674316 6.24999475479126 C 1.003461003303528 3.359134912490845 3.359140872955322 1.003464937210083 6.251201152801514 1.000004887580872 L 23.75 1.000004887580872 C 26.64085006713867 1.003464937210083 28.99653053283691 3.359144926071167 29 6.251194953918457 L 29 23.7500057220459 C 28.9998836517334 24.3556957244873 28.89549446105957 24.95025825500488 28.69346046447754 25.51174545288086 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.252401351928711 1.999994277954102 C 3.910421371459961 2.002805709838867 2.002801895141602 3.910425186157227 2.000001907348633 6.249994277954102 L 2.000001907348633 15.9040699005127 L 5.41560173034668 12.48846530914307 C 6.973701477050781 10.92996406555176 9.045660018920898 10.0715446472168 11.24981117248535 10.07133483886719 C 13.45380020141602 10.07112503051758 15.52590084075928 10.9295539855957 17.0842113494873 12.48829460144043 L 28 23.40407752990723 L 28 6.252395629882812 C 27.99719047546387 3.910425186157227 26.08957099914551 2.002805709838867 23.75 1.999994277954102 L 6.252401351928711 1.999994277954102 M 6.250001907348633 -5.7220458984375e-06 L 23.75 -5.7220458984375e-06 C 27.20007133483887 0.0041351318359375 29.9958610534668 2.799934387207031 30 6.249994277954102 L 30 23.7499942779541 C 29.9997615814209 24.97464561462402 29.63749122619629 26.17189407348633 28.9587516784668 27.19124412536621 L 15.67000102996826 13.90250492095947 C 13.22908973693848 11.46094417572021 9.270906448364258 11.4609432220459 6.830001831054688 13.90249538421631 L 1.9073486328125e-06 20.73249435424805 L 1.9073486328125e-06 6.249994277954102 C 0.004131317138671875 2.799934387207031 2.799930572509766 0.0041351318359375 6.250001907348633 -5.7220458984375e-06 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9819",
    "data-name": "Trac\\xE9 9819",
    d: "M13.893,12.756a3.75,3.75,0,0,0-5.3,0l-8.55,8.55a6.239,6.239,0,0,0,6.2,5.78h17.5a6.21,6.21,0,0,0,3.44-1.041Z",
    transform: "translate(0.009 2.914)",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(19.25 5)",
    fill: "#717171"
  })), /*#__PURE__*/React.createElement("g", {
    id: "picture-2",
    "data-name": "picture",
    transform: "translate(147 172.968)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680-2",
    "data-name": "Rectangle 680",
    width: 34,
    height: 34,
    rx: 6,
    transform: "translate(-2 -1.968)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_9820-2",
    "data-name": "Trac\\xE9 9820",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 28.69346046447754 25.51174545288086 L 16.37711143493652 13.19539451599121 C 15.00778102874756 11.82570457458496 13.1869010925293 11.07133483886719 11.25000095367432 11.07133483886719 C 9.313091278076172 11.07133483886719 7.492220878601074 11.82570457458496 6.122800827026367 13.19548511505127 L 1.000000953674316 18.31828498840332 L 1.000000953674316 6.24999475479126 C 1.003461003303528 3.359134912490845 3.359140872955322 1.003464937210083 6.251201152801514 1.000004887580872 L 23.75 1.000004887580872 C 26.64085006713867 1.003464937210083 28.99653053283691 3.359144926071167 29 6.251194953918457 L 29 23.7500057220459 C 28.9998836517334 24.3556957244873 28.89549446105957 24.95025825500488 28.69346046447754 25.51174545288086 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.252401351928711 1.999994277954102 C 3.910421371459961 2.002805709838867 2.002801895141602 3.910425186157227 2.000001907348633 6.249994277954102 L 2.000001907348633 15.9040699005127 L 5.41560173034668 12.48846530914307 C 6.973701477050781 10.92996406555176 9.045660018920898 10.0715446472168 11.24981117248535 10.07133483886719 C 13.45380020141602 10.07112503051758 15.52590084075928 10.9295539855957 17.0842113494873 12.48829460144043 L 28 23.40407752990723 L 28 6.252395629882812 C 27.99719047546387 3.910425186157227 26.08957099914551 2.002805709838867 23.75 1.999994277954102 L 6.252401351928711 1.999994277954102 M 6.250001907348633 -5.7220458984375e-06 L 23.75 -5.7220458984375e-06 C 27.20007133483887 0.0041351318359375 29.9958610534668 2.799934387207031 30 6.249994277954102 L 30 23.7499942779541 C 29.9997615814209 24.97464561462402 29.63749122619629 26.17189407348633 28.9587516784668 27.19124412536621 L 15.67000102996826 13.90250492095947 C 13.22908973693848 11.46094417572021 9.270906448364258 11.4609432220459 6.830001831054688 13.90249538421631 L 1.9073486328125e-06 20.73249435424805 L 1.9073486328125e-06 6.249994277954102 C 0.004131317138671875 2.799934387207031 2.799930572509766 0.0041351318359375 6.250001907348633 -5.7220458984375e-06 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9819-2",
    "data-name": "Trac\\xE9 9819",
    d: "M13.893,12.756a3.75,3.75,0,0,0-5.3,0l-8.55,8.55a6.239,6.239,0,0,0,6.2,5.78h17.5a6.21,6.21,0,0,0,3.44-1.041Z",
    transform: "translate(0.009 2.914)",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32-2",
    "data-name": "Ellipse 32",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(19.25 5)",
    fill: "#717171"
  })), /*#__PURE__*/React.createElement("g", {
    id: "picture-3",
    "data-name": "picture",
    transform: "translate(157 182.984)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680-3",
    "data-name": "Rectangle 680",
    width: 34,
    height: 34,
    rx: 6,
    transform: "translate(-2 -1.968)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_9820-3",
    "data-name": "Trac\\xE9 9820",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 28.69346046447754 25.51174545288086 L 16.37711143493652 13.19539451599121 C 15.00778102874756 11.82570457458496 13.1869010925293 11.07133483886719 11.25000095367432 11.07133483886719 C 9.313091278076172 11.07133483886719 7.492220878601074 11.82570457458496 6.122800827026367 13.19548511505127 L 1.000000953674316 18.31828498840332 L 1.000000953674316 6.24999475479126 C 1.003461003303528 3.359134912490845 3.359140872955322 1.003464937210083 6.251201152801514 1.000004887580872 L 23.75 1.000004887580872 C 26.64085006713867 1.003464937210083 28.99653053283691 3.359144926071167 29 6.251194953918457 L 29 23.7500057220459 C 28.9998836517334 24.3556957244873 28.89549446105957 24.95025825500488 28.69346046447754 25.51174545288086 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.252401351928711 1.999994277954102 C 3.910421371459961 2.002805709838867 2.002801895141602 3.910425186157227 2.000001907348633 6.249994277954102 L 2.000001907348633 15.9040699005127 L 5.41560173034668 12.48846530914307 C 6.973701477050781 10.92996406555176 9.045660018920898 10.0715446472168 11.24981117248535 10.07133483886719 C 13.45380020141602 10.07112503051758 15.52590084075928 10.9295539855957 17.0842113494873 12.48829460144043 L 28 23.40407752990723 L 28 6.252395629882812 C 27.99719047546387 3.910425186157227 26.08957099914551 2.002805709838867 23.75 1.999994277954102 L 6.252401351928711 1.999994277954102 M 6.250001907348633 -5.7220458984375e-06 L 23.75 -5.7220458984375e-06 C 27.20007133483887 0.0041351318359375 29.9958610534668 2.799934387207031 30 6.249994277954102 L 30 23.7499942779541 C 29.9997615814209 24.97464561462402 29.63749122619629 26.17189407348633 28.9587516784668 27.19124412536621 L 15.67000102996826 13.90250492095947 C 13.22908973693848 11.46094417572021 9.270906448364258 11.4609432220459 6.830001831054688 13.90249538421631 L 1.9073486328125e-06 20.73249435424805 L 1.9073486328125e-06 6.249994277954102 C 0.004131317138671875 2.799934387207031 2.799930572509766 0.0041351318359375 6.250001907348633 -5.7220458984375e-06 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9819-3",
    "data-name": "Trac\\xE9 9819",
    d: "M13.893,12.756a3.75,3.75,0,0,0-5.3,0l-8.55,8.55a6.239,6.239,0,0,0,6.2,5.78h17.5a6.21,6.21,0,0,0,3.44-1.041Z",
    transform: "translate(0.009 2.914)",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32-3",
    "data-name": "Ellipse 32",
    cx: 3.25,
    cy: 3.25,
    r: 3.25,
    transform: "translate(19.25 5)",
    fill: "#717171"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.b7c9125ac3b3c1c8653f0558d656cb1e.svg";
export { ForwardRef as ReactComponent };